import script from "./CardItemsConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./CardItemsConfig.vue?vue&type=script&setup=true&lang=js"

import "./CardItemsConfig.vue?vue&type=style&index=0&id=12d5c43e&scoped=true&lang=scss"

import exportComponent from "D:\\vsts-agent\\_work\\53\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12d5c43e"]])

export default __exports__